export default __webpack_public_path__ + "static/media/google-button.a7f962b9.svg";